import { Responsive, WidthProvider } from 'react-grid-layout'

import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'

const ResponsiveGridLayout = WidthProvider(Responsive)

export default function GridLayout({
  children,
  breakpoints,
  cols,
  layouts,
  rowHeight,
  margin = [16, 16],
  measureBeforeMount = true,
  compactType = 'vertical',
  draggableHandle = '',
  isDraggable = true,
  isResizable = true,
  onBreakpointChange = () => {},
  onLayoutChange = () => {},
  onWidthChange = () => {}
}) {
  return (
    <ResponsiveGridLayout
      breakpoints={breakpoints}
      cols={cols}
      layouts={layouts}
      rowHeight={rowHeight}
      margin={margin}
      measureBeforeMount={measureBeforeMount}
      compactType={compactType}
      draggableHandle={draggableHandle}
      isDraggable={isDraggable}
      isResizable={isResizable}
      onBreakpointChange={onBreakpointChange}
      onLayoutChange={onLayoutChange}
      onWidthChange={onWidthChange}
    >
      {children}
    </ResponsiveGridLayout>
  )
}
